import { computed } from "vue";
import type { Ref } from "vue";
import { WEEKS } from "../constants";

/**
 * 画面表示用ヘルパーに必要な依存をまとめた型。
 */
interface UseDeliveryRequestRegisterUiParams {
  register_no_max_length: Ref<number>;
  receipt_no_max_length: Ref<number>;
  unassignedBlockList: Ref<Array<string | null | undefined>>;
  wordList: Ref<Record<string, string>>;
}

/**
 * 表示可否判定・日付フォーマットなどUI専用ロジックを扱う composable。
 */
export const useDeliveryRequestRegisterUi = ({
  register_no_max_length,
  receipt_no_max_length,
  unassignedBlockList,
  wordList,
}: UseDeliveryRequestRegisterUiParams) => {
  const setRegisterNoDisplay = () => {
    return register_no_max_length.value > 0;
  };

  const setReceiptNoDisplay = () => {
    return receipt_no_max_length.value > 0;
  };

  const formatDate = (date: string): string => {
    let _date;
    let retDate = "";
    if (date) {
      _date = new Date(date);
      retDate =
        _date.getMonth() + 1 + "/" + _date.getDate() + "(" + WEEKS[_date.getDay()] + ")";
    }
    return retDate;
  };

  const areaNotSelectLabel = computed(() => {
    const unassignedBlocks = unassignedBlockList.value!.join(", ");
    return wordList.value.lbl_area_not_select.replace("{{s}}", unassignedBlocks);
  });

  return {
    setRegisterNoDisplay,
    setReceiptNoDisplay,
    formatDate,
    areaNotSelectLabel,
  };
};
